import {methods as Morse} from "./morse";

const SEPARATOR = '/'
export const methods = {
    cypher: function (input, hasCh = false, missing = null, params, sep = SEPARATOR) {
        return Morse.cypher(input, hasCh, missing, params, sep).replaceAll(/\./g, ',').replaceAll(/-/g, '.').replaceAll(/,/g, '-')
    },
    decypher: function (input, hasCh = false, missing = null, params, sep = SEPARATOR) {
        return Morse.decypher(input.replaceAll(/\./g, ',').replaceAll(/-/g, '.').replaceAll(/,/g, '-'), hasCh, missing, params, sep)
    },
    beepIt: async function (cyphered, dotDuration = Morse.getDotDuration) {
        return Morse.beepIt(cyphered,dotDuration)
    },
    stopBeeping:function () {
        return Morse.stopBeeping();
    }
};

export default {...methods,SEPARATOR}